var app = angular.module("leonardo");

var UnitFilters = function(
  $scope,
  $state,
  CategoryRestService,
  ReportService,
  $controller
) {

  $controller('FiltersBaseController', {$scope: $scope});
  if (!$scope.filterService.hasFilter('property_reports') && $scope.filterService.currentProperty) {
    $scope.filterService.setFilter('property_reports', $scope.filterService.currentProperty.id, true);
  }

  $scope.unit_type = $state.current.unit_type;

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account && !$scope.unit_type,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account && !$scope.unit_type,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account && !$scope.unit_type,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'unit_number_search',
      name: 'Unit Number',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Unit number',
      condition: !$scope.unit_type,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'unit_building_search',
      name: 'Unit Building',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Unit building',
      condition: !$scope.unit_type,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'type_name',
      name: 'Type Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Type Name',
      condition: !!$scope.unit_type,
      onSubmit: $scope.filter,
      conflicts: []
    }
  ];

  $scope.filterService.showFilters(['property_reports', 'unit_number_search', 'unit_building_search']);
  
};

app.controller('UnitFilters', [
  '$scope',
  '$state',
  'CategoryRestService',
  'ReportService',
  '$controller',
  UnitFilters
]);
